import { render, staticRenderFns } from "./ItemsOfDayTable.vue?vue&type=template&id=f90d6c4e&scoped=true&"
import script from "./ItemsOfDayTable.vue?vue&type=script&lang=js&"
export * from "./ItemsOfDayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90d6c4e",
  null
  
)

export default component.exports